<template>
  <div class="idea">
    <el-row>
      <el-col class="idea-left">
        <h2>人才理念</h2>
        <p class="underline"></p>
        <p class="idea-p">{{config.concept}}</p>
      </el-col>
      <el-col class="idea-right">
        <img :src="config.image" alt />
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {}
    };
  },
  created() {
    this.config = this.$cache.get("recruitConfig") || {};
  }
};
</script>
<style lang="less" scoped>
.idea {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  .el-row {
    display: flex;
    align-items: center;

    .idea-left {
      width: 594px;
      height: 100%;
      padding: 27px 48px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 22px 0;
      }
      .idea-p {
        font-size: 16px;
        color: #555555;
        line-height: 28px;
      }
    }
    .idea-right {
      width: 606px;
      height: 402px;
      font-size: 0;
      img {
        width: 606px;
        height: 402px;
      }
    }
  }
}
</style>


